//

import { mapGetters } from "vuex";
import SmartContractVarDeclaration from "@/components/SmartContractDesigner/handlers/Variables/DeclareHandler/Declaration/Declaration.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "DeclareHandler",
    components: {
        SmartContractVarDeclaration,
        AQModal,
        AQInput,
        AQButton,
        AQCheckbox,
        AQCard,
        AQDialog
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["selectedPluginData", "inEditFunction"]),
        ...mapGetters("apps", ["currentApp"])
    },
    props: {
        readonly: Boolean
    },
    data() {
        return {
            displayAddEditModal: false,
            inEditOrAddEntry: null,
            declareDescription: "",
            add: false,
            edit: false,
            inEditOrAddFunc: null,
            saveButton: { label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"), disabled: false },
            defaultValue: "",
            dialogOpen: false,
            entryClone: {},
            defaultShowValue: ""
        };
    },
    mounted() {
        if (this.selectedPluginData) {
            this.declareDescription = this.selectedPluginData.description;
        }
    },
    methods: {
        actionsDlg($event) {
            if ($event === "primary") {
                if (this.checkForDeclaredVar() || this.checkForParams()) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("generic.warning"),
                        detail: this.$t("smartContract.manageFunctions.duplicateParams")
                    });
                } else if (this.add) {
                    if (Array.isArray(this.inEditOrAddEntry.type)) {
                        const typeData = this.inEditOrAddEntry.type[0].data;
                        this.inEditOrAddEntry.type = typeData;
                    }
                    this.$store.commit(
                        "smartContractDesigner/addEntryToSelectedDataset",
                        {
                            property: "declareList",
                            data: this.inEditOrAddEntry,
                            description: this.declareDescription
                        }
                    );
                }
                if (
                    this.edit !== null
          && this.edit !== false
          && this.edit !== undefined
                ) {
                    if (Array.isArray(this.inEditOrAddEntry.type)) {
                        const typeData = this.inEditOrAddEntry.type[0].data;
                        this.inEditOrAddEntry.type = typeData;
                    }
                    this.$store.commit(
                        "smartContractDesigner/updateEntryToSelectedDataset",
                        {
                            property: "declareList",
                            index: this.inEditIndex,
                            data: this.inEditOrAddEntry,
                            description: this.declareDescription
                        }
                    );
                }
                this.displayAddEditModal = false;
            }
            if ($event === "close") {
                if (!this.entryClone.type) {
                    this.entryClone.type = [];
                }
                if (JSON.stringify(this.entryClone) === JSON.stringify(this.inEditOrAddEntry)) {
                    this.displayAddEditModal = false;
                } else {
                    this.dialogOpen = true;
                }
            }
            this.$emit("input");
        },
        commitDescription() {
            this.$store.commit(
                "smartContractDesigner/addEntryToSelectedDataset",
                {
                    property: "declareList",
                    description: this.declareDescription
                }
            );
        },
        checkForDeclaredVar() {
            let found = false;
            if (this.inEditFunction && this.inEditFunction.body) {
                const declareList = this.inEditFunction.body.filter(fnc => fnc.nodeType === "DECLARE");
                if (declareList && declareList.length) {
                    let concatDeclaredVar = [];
                    declareList.forEach(el => {
                        concatDeclaredVar = [...concatDeclaredVar, ...el.declareList];
                    });
                    const concatDeclaredMapped = concatDeclaredVar.map(elem => elem.variable);
                    if (this.edit) {
                        found = concatDeclaredMapped.some((elem, index) => concatDeclaredMapped.indexOf(elem) != index);
                    } else {
                        found = concatDeclaredMapped.some(el => el === this.inEditOrAddEntry.variable);
                    }
                }
            }
            return found;
        },

        checkForParams() {
            let paramsArray = []; let
                isDuplicate = false;
            paramsArray = this.inEditFunction.inParameters.concat(this.inEditFunction.outParameters);
            if (paramsArray && paramsArray.length) {
                const parametersArray = paramsArray.map(elem => elem.name);
                isDuplicate = parametersArray.some((elem) => elem === this.inEditOrAddEntry.variable);
            }
            return isDuplicate;
        },
        okAction() {
            this.inEditIndex = null;
            this.displayAddEditModal = false;
            this.add = this.edit = false;
            this.inEditOrAddEntry = false;
        },
        addNewDeclaration() {
            this.inEditOrAddEntry = {
                id: this.selectedPluginData.id,
	      index: 0,
	      description: "",
	      nodeType: "DECLARE_ELEMENT",
                variable: "",
                type: null,
                isArray: false
            };
            this.add = this.displayAddEditModal = true;
            this.defaultValue = "";
            this.entryClone = JSON.parse(JSON.stringify(this.inEditOrAddEntry));
        },
        editDeclaration(index) {
            this.inEditOrAddEntry = {

                ...this.selectedPluginData.declareList[index]
            };
            if (this.inEditOrAddEntry.type.id) {
                this.defaultValue = this.inEditOrAddEntry.type.id;
            } else {
                this.defaultValue = this.inEditOrAddEntry.type.type;
            }
            this.edit = this.displayAddEditModal = true;
            this.inEditIndex = index;
            this.entryClone = JSON.parse(JSON.stringify(this.inEditOrAddEntry));
        },
        deleteDeclaration(index) {
            this.$store.commit(
                "smartContractDesigner/removeEntryFromSelectedDataset",
                { property: "declareList", data: index }
            );
        }
    }
};
